const dotenv = require("dotenv");
const result = dotenv.config();

// module.exports = {
//   REACT_APP_APIKEY: "da8d7d441720574fefc26ae1ce88de7f",
// };

export const REACT_APP_APIKEY = "da8d7d441720574fefc26ae1ce88de7f";
